const state = {
  selectedTab: '',
};

const mutations = {
  setSelectedTab(state, data) {
    state.selectedTab = data.selectedTab;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
